import { Store } from 'redux'
import * as Actions from 'redux/actions'
import { minBy } from 'lodash'

export const getInlineComment = (uuid?: string) => {
  if (!uuid) return []
  return document.querySelectorAll(`mark[data-uuid='${uuid}']`)
}

export const unhighlightActiveComment = (store: Store) => {
  store.dispatch(Actions.setActiveComment(undefined, false))
}

export const unHighlightHighlightedComment = (store: Store) => {
  store.dispatch(Actions.setHighlightedComment(undefined))
}

/**
 * Find all marks that have an attribute data-uuid containing the given uuid.
 * The attribute can contain a list of uuids separated by spaces, so we use *=
 * to find the uuid as a substring of the attribute value.
 * @param uuid The uuid of the comment to find. NOTICE: this should not be
 * undefined, not sure why the type allows it. We should most probably narrow
 * it.
 * @returns All the nodes with data-uuid containing the given uuid
 */
export const findAllCommentMarks = (uuid: string | undefined) =>
  document.querySelectorAll<HTMLElement>(`[data-uuid*='${uuid}']`)

/**
 * Finds the first visible ancestor of the element, including itself. If the
 * found element is a toggle_list, returns the first line of its summary.
 */
export const firstVisibleParent = (startEl: HTMLElement): HTMLElement | null => {
  let el: HTMLElement | null = startEl
  while (el != null && el.offsetParent == null) {
    el = el.parentElement
  }
  if (el != null && el.getAttribute('data-node-type') === 'toggle_list') {
    return (
      el.querySelector('summary > p > span') || el.querySelector('summary > p') || el.querySelector('summary') || el
    )
  }
  return el
}

export const findCommentText = (uuid: string | undefined): string => {
  const commentMarks = [...findAllCommentMarks(uuid)]

  return commentMarks.reduce((commentText, mark) => commentText + mark.textContent, '')
}

export const targetCommentMark = (event: Event) => {
  const eventTarget = event.target as HTMLElement
  const parentCommentMarks = findUndresolvedCommentMarks(eventTarget)

  const parentCommentMark = minBy(parentCommentMarks, (mark) => findCommentText(mark.dataset.uuid).length)

  if (
    eventTarget.dataset?.visible === 'true' ||
    (eventTarget.parentElement?.dataset?.visible === 'true' && !!parentCommentMark)
  ) {
    return parentCommentMark as HTMLElement
  }
}

export const COMMENT_MARK_SELECTOR = "[data-type='comment'][data-resolved='false']"

export const findUndresolvedCommentMarks = (element: HTMLElement): HTMLElement[] => {
  const commentMarks: HTMLElement[] = []

  let parentElement: HTMLElement | null = element
  while (parentElement) {
    if (parentElement.matches(COMMENT_MARK_SELECTOR)) commentMarks.push(parentElement)

    parentElement = parentElement.parentElement
  }

  return commentMarks
}
